<template>

  <div>
    <b-row>
      <b-col
        md="12"
        sm="12"
      >
        <b-card>

          <b-form

            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>
              <b-col md="4"> <b-form-group
                :label="$t('Başlangıç Tarihi')"
                label-for="name"
              >
                <b-form-datepicker
                  id="start_date"
                  v-model="filterData.start_date"
                  class="mb-1"
                />
              </b-form-group></b-col>
              <b-col md="4"> <b-form-group
                :label="$t('Bitiş Tarihi')"
                label-for="name"
              >
                <b-form-datepicker
                  id="end_date"
                  v-model="filterData.end_date"
                  class="mb-1"
                />
              </b-form-group></b-col>

            </b-row>

            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="refetchData"
              >
                Filtrele
              </b-button>
            </div>
          </b-form>

        </b-card>

      </b-col>
      <b-col>
        <!-- Filters -->

        <!-- Table Container Card -->
        <b-card
          no-body
          class="mb-0"
        >

          <div class="m-2">

            <!-- Table Top -->
            <b-row>

              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>{{ $t('Show') }}</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>{{ $t('Entries') }}</label>
              </b-col>

              <!-- Search -->
              <b-col
                cols="12"
                md="6"
              >
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />

                </div>
              </b-col>
            </b-row>

          </div>

          <b-table
            ref="refOrderListTable"
            class="position-relative"
            :items="fetchOrders"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="No matching records found"
          >
            <template #cell(creator)="data">
              <b-badge
                pill
                variant="info"
                class="text-capitalize"
              >
                <b-badge
                  v-if="data.item.creator==2"
                  variant="info"
                  class="badge-round"
                >
                  {{ $t('Otomatik Oluşturulan') }}
                </b-badge>
              </b-badge>
            </template>
            <template #cell(date)="data">
              <span>{{ $format_datetime(data.item.date) }}</span>
            </template>
            <template #cell(payment_type)="data">
              <span>{{ data.item.payment_type.payment_type_name }}</span>
            </template>
            <template #cell(total_price)="data">
              <span>{{ $staticParams.formatCurrency(data.item.total_price) }}</span>
            </template>
            <template #cell(status_params)="data">
              <b-badge :variant="$staticParams.getOrderStatusType(data.item.status_params.type).variant">
                {{ $staticParams.getOrderStatusType(data.item.status_params.type).name }}
              </b-badge>
            </template>
            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >

                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item :to="{ name: 'reports-order-detail', params: { id: data.item.id } }">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">{{ $t('Sipariş Detayı') }}</span>
                </b-dropdown-item>

              </b-dropdown>
            </template>

          </b-table>
          <div class="mx-2 mb-2">
            <b-row>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >

                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalOrders"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BFormInput, BTable, BDropdown, BDropdownItem, BPagination, BFormDatepicker, BButton, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onUnmounted, watch, computed,
} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import reportsStoreModule from '../reportsStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BBadge,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
    BFormDatepicker,
    BButton,
    BForm,
    BFormGroup,
  },
  data() {
    return {

    }
  },
  created() {
    const today = this.$moment()
    const startDay = this.$moment()
    this.filterData.end_date = today.format()
    this.filterData.start_date = startDay.subtract(7, 'days').format()
  },
  methods: {

  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, reportsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const toast = useToast()
    // eslint-disable-next-line no-unused-vars
    const editProductId = ref(0)
    const isAddNewProductSidebarActive = ref(false)
    const isEditProductSidebarActive = ref(false)

    const perPageOptions = [10, 25, 50, 100]
    const perPage = ref(10)
    const searchQuery = ref('')
    const totalOrders = ref(0)
    const refOrderListTable = ref(null)
    const currentPage = ref(1)
    const filterData = ref({
      start_date: null,
      end_date: null,
    })

    const tableColumns = [
      { key: 'customer_name', label: 'Müşteri', sortable: false },
      { key: 'date', label: 'Sipariş Zamanı', sortable: false },
      { key: 'status_params', label: 'Durum', sortable: false },
      { key: 'payment_type', label: 'Ödeme Yöntemi', sortable: false },
      { key: 'total_price', label: 'Sipariş Tutarı', sortable: false },
      { key: 'actions' },
    ]

    const refetchData = () => {
      refOrderListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, filterData], () => {
      refetchData()
    })
    const dataMeta = computed(() => {
      const localItemsCount = refOrderListTable.value ? refOrderListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalOrders.value,
      }
    })
    const fetchOrders = (ctx, callback) => {
      store
        .dispatch('app-reports/fetchOrderList', {
          q: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          start_date: filterData.value.start_date,
          end_date: filterData.value.end_date,
        })
        .then(response => {
          const { data } = response.data
          const { total } = response.data.meta
          callback(data)
          totalOrders.value = total
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching product list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
    return {

      // Sidebar
      isAddNewProductSidebarActive,
      isEditProductSidebarActive,
      tableColumns,
      // Filter
      avatarText,
      perPageOptions,
      perPage,
      dataMeta,
      fetchOrders,
      searchQuery,
      totalOrders,
      currentPage,
      refetchData,
      // UI
      refOrderListTable,
      filterData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
